import React, { FC, Suspense } from "react";

import {
  ContentWrapper,
  MainAction,
} from "../../components/forms/steppedInvoice";
import { SteppedInvoiceLayout } from "../../layouts/SteppedInvoice/Layout";

export const SteppedInvoice: FC = () => {
  return (
    <Suspense fallback={Loader}>
      <SteppedInvoiceLayout action={<MainAction />}>
        <ContentWrapper />
      </SteppedInvoiceLayout>
    </Suspense>
  );
};

const Loader = <>Loading...</>;
